export default __webpack_public_path__ + "static/media/ema.65f48ef2.jpg";